import { Component, Input, OnInit, ViewEncapsulation } from "@angular/core";

@Component({
    selector: 'question-feedback',
    templateUrl: "./question-feedback.component.html",
    styleUrls: ["./question-feedback.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class QuestionFeedbackComponent implements OnInit {
    @Input() questionNumber: number;
    feedback: string;

    get jsPanelContentHeight() {
        if (document.getElementsByClassName("jsPanel-content").length) {
            return document.getElementsByClassName("jsPanel-content")[0].clientHeight;
        }
        else {
            return document.body.clientHeight;
        }
    }

    get labelHeight() {
        if (document.getElementById("q-f-label")) {
            return document.getElementById("q-f-label").clientHeight;
        } else {
            return 32;

        }
    }

    get textareaHeight() {
        return this.jsPanelContentHeight - this.labelHeight - 30;
    }

    constructor() {
    }

    ngOnInit(): void {
    }
}
